module.exports = __webpack_public_path__ + "img/home_video_thumbnail.890a58bf.jpg";